import { alpha, Components, Theme } from '@mui/material'
import { basicTheme, buttonSize } from '../theme-v2'

export const MuiLinearProgress: Components<Theme>['MuiLinearProgress'] = {
    defaultProps: {
        size: 'small',
        variant: 'determinate',
    },
    variants: [
        {
            props: { meter: true },
            style: (props: any) => {
                const height = buttonSize[props.ownerState.size]
                const innerHeight = `calc(${height} / 5)`
                return {
                    // compensate for outline
                    height: `calc(${height} - 4px)`,
                    outline: '2px solid #777',
                    backgroundColor: '#393939',
                    border: '2px solid',
                    borderColor: basicTheme.palette.background.default,
                    margin: '2px',
                    borderRadius: '6px',
                    '& .MuiLinearProgress-bar': {
                        borderRadius: '4px',
                        overflow: 'hidden',
                        '::before': {
                            content: '""',
                            position: 'absolute',
                            borderRadius: '2px 2px 0px 0px',
                            width: `calc(${props['aria-valuenow']}% - 4px)`,
                            right: '2px',
                            top: '2px',
                            height: innerHeight,
                            backgroundColor: alpha(basicTheme.palette.common.white, 0.8),
                            transition: 'width .4s linear',
                        },
                        '::after': {
                            content: '""',
                            position: 'absolute',
                            borderRadius: '0px 0px 2px 2px ',
                            width: `calc(${props['aria-valuenow']}% - 4px)`,
                            transition: 'width .4s linear',
                            right: '2px',
                            bottom: '2px',
                            height: innerHeight,
                            backgroundColor: basicTheme.palette[props.ownerState.color].dark,
                        },
                    },
                }
            },
        },
    ],
}
